import { PortalMemberSummary } from "../../features/portal/models/PortalMe";
import PortalMemberSwitcher from "./PortalMemberSwitcher";

interface PortalPageHeadingProps {
  title: string;
  intro?: string;
  /** Self first, then the wards; the switcher shows only when there is more than one. */
  members: PortalMemberSummary[];
  memberId: string | null;
  onSelectMember: (memberId: string) => void;
  /** Off where the section's cards are the signed-in member's own, not the shown member's. */
  showSwitcher?: boolean;
}

/** The top of every portal section: the title, one intro line and the guardian's switcher. */
const PortalPageHeading = ({
  title,
  intro,
  members,
  memberId,
  onSelectMember,
  showSwitcher = true,
}: PortalPageHeadingProps) => (
  <>
    <h1 className={`${intro ? "mb-1" : "mb-4"} text-2xl font-bold text-grey-20 dark:text-white`}>{title}</h1>
    {intro && <p className="mb-6 text-sm text-grey-40 dark:text-grey-80">{intro}</p>}
    {showSwitcher && memberId && <PortalMemberSwitcher members={members} selectedMemberId={memberId} onSelect={onSelectMember} />}
  </>
);

export default PortalPageHeading;
